<div fxHide.gt-sm="true" class="desk-image"></div>

<div class="container desk-color" fxLayout="row" fxLayoutAlign="center center">
    <div class="container-router light-shadow ">
        <router-outlet></router-outlet>
    </div>
    <span class="version">xidden.tech | v{{ version }}-{{ build }}</span>
</div>